import { Grid } from "@material-ui/core";
import MeditocInfoField from "../../../utils/MeditocInfoField";
import MeditocModal from "../../../utils/MeditocModal";
import MeditocTable from "../../../utils/MeditocTable";
import { getDetalleArchivoColumns } from "../../../../models/EmpresaModel";
import { useEmpresa } from "../../../../context/EmpresaContext";
import { useState } from "react";

export default function DetalleArchivoVerificado() {
    const {
        listaFoliosArchivoVerificado,
        modalOpenDetalleArchivoVerificado,
        handleOpenDetalleArchivoVerificado,
        handleClickRegresar,
        handleSubmitCargarArchivo,
    } = useEmpresa();

    //No hace nada
    const [folio, setFolio] = useState({});

    if (!listaFoliosArchivoVerificado) return null;

    return (
        <MeditocModal
            level={2}
            size="small"
            title="Confirmar folios"
            cancelMessage="Regresar"
            cancelFunc={handleClickRegresar}
            okfunc={handleSubmitCargarArchivo}
            open={modalOpenDetalleArchivoVerificado}
            setopen={handleOpenDetalleArchivoVerificado}
            okDisabled={listaFoliosArchivoVerificado.totalFolios < 1}
        >
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <MeditocInfoField label="Producto:" value={listaFoliosArchivoVerificado.entProducto.sNombre} />
                </Grid>
                <Grid item xs={12}>
                    <MeditocInfoField label="Folios encontrados:" value={listaFoliosArchivoVerificado.totalFolios} />
                </Grid>
                <Grid item xs={12}>
                    <MeditocTable
                        id="sFolio"
                        row={folio}
                        setRow={setFolio}
                        columns={getDetalleArchivoColumns()}
                        data={listaFoliosArchivoVerificado.lstFolios}
                    />
                </Grid>
            </Grid>
        </MeditocModal>
    );
}
